import { Alert } from 'ui/baseComponents'
import { EMAIL_SUPPORT } from 'ui/consts'

const AlertError = ({ onClose }) => (
  <Alert {...{ onClose, severity: 'error' }}>
    There was a problem updating the patient's information. If the issue
    persists, please contact {EMAIL_SUPPORT}.
  </Alert>
)

export default AlertError
